import {axios, HOST, config} from './settiing';

export default {
  getDeliveryListByDate(start, end) {
    return axios.get( `${HOST}/manage/delivery/list/${start}/${end}`, config);
  },
  updateDeliveryState(data) {
    return axios.put( `${HOST}/manage/delivery/state`, data, config);
  },
  createDelivery(request) {
    return axios.post( `${HOST}/manage/delivery`, request, config);
  },
  manualDelivery(data) {
    return axios.put(`${HOST}/manage/delivery/manual`, data, config);
  },
  getDetailInfo(id) {
    return axios.get( `${HOST}/manage/delivery/${id}`, config);
  },
  getPayLog(id) {
    return axios.get( `${HOST}/manage/delivery/paylog/${id}`, config);
  },

  updateDeliveryFee(data) {
    return axios.put( `${HOST}/manage/delivery/fee`, data, config);
  },

  getRecentList(customerId) {
    return axios.get( `${HOST}/manage/delivery/recent/${customerId}`, config);
  },

  cancelDelivery(data) {
    return axios.put(`${HOST}/manage/delivery/cancel`, data, config);
  }
}